import Vue from 'vue';
import Antd from 'ant-design-vue';
import App from '@/App';
import router from '@/router';
import store from '@/store/store';
// import 'ant-design-vue/dist/antd.css';
import '@/style/theme.less';
import PortalVue from 'portal-vue';
import money from 'v-money';

Vue.use(PortalVue)
Vue.config.productionTip = false;
Vue.use(Antd);
Vue.use(money, {precision: 4});

Vue.directive('ant-input-focus', {
	// Quando o elemento vinculado é inserido no DOM...
	inserted: function (el) {
		// Coloque o foco no elemento
		setTimeout(() => {
			el.children[1].focus()
		}, 1000);
	}
})

new Vue({
	router,
	store,
	render: h => h(App),
	data: {
		loadingSpinner: false
	}
}).$mount('#app');
